import { render, staticRenderFns } from "./AddQualPayment.vue?vue&type=template&id=35ac0676&scoped=true"
import script from "./AddQualPayment.vue?vue&type=script&lang=js"
export * from "./AddQualPayment.vue?vue&type=script&lang=js"
import style0 from "./AddQualPayment.vue?vue&type=style&index=0&id=35ac0676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac0676",
  null
  
)

export default component.exports